import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { DefinePasswordComponent } from './define-password/define-password.component';
import { DefineSubscribeComponent } from './define-subscribe/define-subscribe.component';
import { LostMyPassComponent } from './lost-my-pass/lost-my-pass.component';
import { AutenticationComponent } from './autentication.component';
import { SlickModule } from 'ngx-slick';
import { MatButtonModule, MatCheckboxModule, MatListModule,
	MatRadioModule, MatSelectModule, MatProgressSpinnerModule, MatNativeDateModule, MatCardModule } from '@angular/material';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgxMaskModule } from 'ngx-mask';
import { MyCpfComponent } from './my-cpf/my-cpf.component';
import { AutenticationService } from './autentication.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserAndPassComponent } from './user-and-pass/user-and-pass.component';
import { AuthMessageComponent } from './auth-message/auth-message.component';
import { AccountsListComponent } from './accounts-list/accounts-list.component';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { AutenticationGuard } from './autentication.guard';
import { RouterModule } from '@angular/router';
import { PassMonitorComponent } from './pass-monitor/pass-monitor.component';
import { SecurityCheckComponent } from './security-check/security-check.component';
import { TextMaskModule } from 'angular2-text-mask';
import { SmsValidationComponent } from './sms-validation/sms-validation.component';
import { TokenValidationComponent } from './token-validation/token-validation.component';
import { RedefinePasswordComponent } from './redefine-password/redefine-password.component';
import { ChannelsAndFeesComponent } from './channels-and-fees/channels-and-fees.component';
import { AttendantAuthComponent } from './attendant-auth/attendant-auth.component';
import { SecurityCheckRegistrationComponent } from './security-check-registration/security-check-registration.component';
import { InfoComponent } from './security-check-registration/info/info.component';
import { RegistrationComponent } from './security-check-registration/registration/registration.component';
import { RedefinePasswordWithStepsComponent } from './redefine-password-with-steps/redefine-password-with-steps.component';
import { DefineSubscribeWithStepsComponent } from './define-subscribe-with-steps/define-subscribe-with-steps.component';
import { DefinePasswordWithStepsComponent } from './define-password-with-steps/define-password-with-steps.component';
import { OAuthTokenService } from './o-auth-token.service';

@NgModule({
	imports: [
		RouterModule,
		CommonModule,
		SlickModule.forRoot(),
		MatCheckboxModule,
		MatButtonModule,
		MatDatepickerModule,
		MatNativeDateModule,
		NgxMaskModule.forRoot(),
		MatProgressSpinnerModule,
		FormsModule,
		ReactiveFormsModule,
		MatSelectModule,
		SharedModule,
		MatListModule,
		MatRadioModule,
		MalihuScrollbarModule.forRoot(),
		TextMaskModule,
		MatCardModule
	],
	declarations: [
		LoginComponent,
		DefinePasswordComponent,
		RedefinePasswordComponent,
		DefineSubscribeComponent,
		LostMyPassComponent,
		AutenticationComponent,
		MyCpfComponent,
		UserAndPassComponent,
		AuthMessageComponent,
		AccountsListComponent,
		PassMonitorComponent,
		SecurityCheckComponent,
		SmsValidationComponent,
		TokenValidationComponent,
		ChannelsAndFeesComponent,
		AttendantAuthComponent,
		SecurityCheckRegistrationComponent,
		InfoComponent,
		RegistrationComponent,
		RedefinePasswordWithStepsComponent,
		DefineSubscribeWithStepsComponent,
		DefinePasswordWithStepsComponent
	],
	providers: [
		AutenticationService,
		AutenticationGuard,
		OAuthTokenService
	]
})
export class AutenticationModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/autentication.module.ts